module.exports = __webpack_public_path__ + "img/dolphin.37a81580.png";